/* eslint-disable import/no-unresolved */
import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { selectAuth } from '@/store/selectors';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const fetcher = ({ queryKey }: any) => {
  const url = queryKey[1];
  const infoType = queryKey[2];
  const response = axios
    .get(`https://${url}/api/resource/${infoType}`, {
      withCredentials: true,
    })
    .then((data) => data.data)
    .catch((error) => error.response.message);

  return response;
};

// eslint-disable-next-line import/prefer-default-export
export const useFetchInfo = (infoType: 'Company' | 'Cost Center') => {
  const { url } = useSelector(selectAuth);
  return useQuery(['info', url, infoType], fetcher, {
    enabled: !!infoType,
  });
};
